/**
 * Created by Claude on 11.08.2026
 */

const PackWindow = Prefab.createWindow(
    "starter_pack",
    "packwindow_prefab_json",
    {
        theme: (offer) => bundles.starter_pack.jsons[`${offer.logic.getProduct().itemId.toLowerCase()}_theme_json`]
    }
);

cleverapps.styles.DECORATORS = cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    PACKWINDOW_LABEL_STROKE: {
        color: cleverapps.styles.COLORS.BLACK,
        size: 1
    }
});

// Named by the themes - every ui points its fonts.reward / fonts.title at one of these.
cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PACKWINDOW_LABEL_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.PACKWINDOW_LABEL_STROKE
    },
    PACKWINDOW_TEXT: {
        name: "big_digits",
        size: 80,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            color: new cc.Color(85, 1, 91),
            size: 3
        },
        shadow: {
            color: new cc.Color(85, 1, 91),
            direction: cc.size(0, -5),
            blur: 1
        }
    }
});